var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeNotificationPopover,
          expression: "closeNotificationPopover"
        }
      ],
      attrs: {
        width: "496",
        trigger: "manual",
        visibleArrow: false,
        popperClass: "notifications-popover pt-3 px-2 pb-0"
      },
      scopedSlots: _vm._u([
        {
          key: "reference",
          fn: function() {
            return [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    content: _vm.$t.__("header.Notifications.notifications"),
                    placement: "bottom",
                    delay: { show: 1000, hide: 0 },
                    arrow: false
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "notifications__icon-container" },
                    [
                      _c("CompassIcon", {
                        staticClass: "notifications__icon",
                        attrs: { icon: "notification" }
                      }),
                      _vm._v(" "),
                      _vm.unreadNotificationsCounter
                        ? _c("span", { staticClass: "notifications__badge" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.unreadNotificationsCounter > 99
                                    ? "99+"
                                    : _vm.unreadNotificationsCounter
                                ) +
                                "\n                "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleChangeTab },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t.__("header.Notifications.notifications"),
                    name: "notifications"
                  }
                },
                [
                  _vm.visible && _vm.activeTab === "notifications"
                    ? _c("notifications-list", {
                        attrs: {
                          unreadNotificationsCounter:
                            _vm.unreadNotificationsCounter
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t.__("header.Notifications.alert"),
                    name: "alerts"
                  }
                },
                [
                  _vm.alerts && _vm.hasAlertsSetuped
                    ? _c(
                        "ul",
                        { attrs: { id: "alerts-list" } },
                        _vm._l(_vm.alerts, function(alert, name) {
                          return _c(
                            "li",
                            {
                              key: name,
                              staticClass: "headnotif p-1",
                              attrs: { id: "notif-" + alert.name }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "headnotif-header br",
                                  on: {
                                    click: function($event) {
                                      return _vm.triggerAlertCallback(alert)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "label label-nobackground" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            "spanLabel spanLabelNotif " +
                                            (alert.nbAlerts > 0
                                              ? "spanLabel-red"
                                              : "spanLabel-lightgrey-disabled")
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                alert.nbAlerts > 1000
                                                  ? "1000+"
                                                  : alert.nbAlerts
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(alert.txt))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "headnotif-detail hidden"
                              })
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.alerts && !_vm.hasAlertsSetuped
                    ? _c(
                        "div",
                        { staticClass: "placeholder" },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__("Aucune alerte n'est paramétrée")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("CompassButton", {
                            staticClass: "mb-2",
                            attrs: {
                              label: _vm.$t.__(
                                "header.Notifications.configure_alert"
                              )
                            },
                            on: { click: _vm.redirectToProfilPreferences }
                          })
                        ],
                        1
                      )
                    : _c("div", { staticClass: "placeholder" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$l10n.__("Chargement des alertes")))
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-spin fa-cog fa-blue fa-30"
                        })
                      ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("CompassIconButton", {
            staticClass: "notifications__settings-icon",
            attrs: { icon: "settings-fill" },
            on: { click: _vm.redirectToProfilPreferences }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }